import React from 'react'
import HeaderCheck from './ProgressChecks/HeaderCheck'
import PositionsCheck from './ProgressChecks/PositionsCheck'
import styled from 'styled-components'
import { useLocalReturnDataState } from '../../../stores/LocalReturnDataProvider'


const StyledList = styled.ul`
  list-style: none;
  margin: 5px 0 0 0;
  padding: 0;
  font-size: 18px;

  li {
    padding: 10px 0;
  }
`

const Progress = ({isStoring}) => {
  const { positions, headerData} = useLocalReturnDataState()
  return (
    <StyledList>
      {!isStoring &&
      <li>
        <HeaderCheck headerData={headerData} />
      </li>
      }
      <li>
        <PositionsCheck positions={positions} />
      </li>
    </StyledList>
  )
}

export default Progress
